import { useRef, useState } from "react";
import Button from "../Button/Button.jsx";
import cx from "classnames";

import useClickAway from "../../common/useClickAway.js";

import { string } from "prop-types";

const propTypes = {
  formHTML: string.isRequired,
};

const NotLoggedIn = (props) => {
  const { formHTML } = props;
  const [isOpen, setOpen] = useState(false);

  const formRef = useRef();
  const loginRef = useClickAway({ isOpen, setOpen });

  const handleLoginClick = (e) => {
    setOpen(true);
  };

  return (
    <div
      className={cx("login-button", {
        "login-button--is-open": isOpen,
      })}
      ref={loginRef}
    >
      <Button className="btn--primary-ghost" onClick={handleLoginClick}>
        Log In
      </Button>

      <div className="login-button__dropdown">
        {/* it's important that the formHTML is always here so jquery can attach it's events */}
        <div dangerouslySetInnerHTML={{ __html: formHTML }} ref={formRef} />
      </div>
    </div>
  );
};

NotLoggedIn.propTypes = propTypes;
export default NotLoggedIn;
